module.exports = __webpack_public_path__ + "media/agent_4_furufuru.09b114d5.mp3";